import React, { useState, useEffect } from 'react';
import T from 'prop-types';

import { isEmpty, debounce, orderBy } from 'lodash-es';

import AlertBlock from '../../../../../components/AlertBlock';
import { SortableTable } from '../../../../../components/SortableTable';
import { publishersColumns } from '../configs/table-config';
import scrollPage from '../../../../../utils/scrollPage';
import PayWall from '../../shared/components/PayWall';

const TopPublishersTable = ({
  report,
  onShowMore,
}) => {
  const [rows, setRows] = useState([]);
  const emptyCell = <span>-</span>;
  const scrollTo = debounce(() => {
    const el = document.querySelector('.solutions-hubspot-form-box.solutions-hubspot-form');
    scrollPage({
      destination: el.getBoundingClientRect().y + 500,
      duration: 500,
    });
  }, 500);
  const handleShowMore = () => {
    onShowMore();
  };
  const {
    store_type,
    publishers,
  } = report.data;
  const initialrows = sliced => sliced.map((td, i) => ({
    name: (
      <a className="text-truncate" href={`${window.location.origin}/publishers/${store_type}/${td.publisher_id}`}>
        {td.name}
      </a>
    ),
    total_apps_count: td.total_apps_count || emptyCell,
    downloads_rank: td.downloads_rank || emptyCell,
    total_revenue_rank: td.total_revenue_rank || emptyCell,
    mau_rank: td.mau_rank || emptyCell,
    mau: i === 0 ? <PayWall onClick={scrollTo} /> : null,
    mau_td_props: {
      colSpan: 3,
      rowSpan: 50,
      id: 'paywall-column',
      className: 'bg-gray b-r b-b paywall-column',
    },
  }));

  useEffect(() => {
    setRows(initialrows(publishers.slice(0, 25)));
  }, [])

  const handleSort = (obj) => {
    const newRows = orderBy(publishers, [obj.sortBy], [obj.sortOrder]).slice(0, 25);
    const upRows = initialrows(newRows);
    setRows(upRows);
  }

  const staticHeader = (
    <tr>
      <th colSpan="2">
        <div className="hidden">text</div>
      </th>
      <th className="text-xxs-center" colSpan="3">Apptopia Proprietary Ranks</th>
      <th className="text-xxs-center" colSpan="3">Last 30 Days’ Performance</th>
    </tr>
  );

  return (
    <div className="top-charts-main">
      <div className="top-charts-table-box">
        {!isEmpty(report) ? (
          <div className="table-responsive pos-rel">
            <SortableTable
              tableClassName="table-default table-hover sticky-header top-charts"
              rows={rows}
              columns={publishersColumns}
              emptyStateText="No data to display"
              showMoreCellColSpan={10}
              showEmptyCells={false}
              showMoreCellSimplified
              hasShowMoreCell
              initialRowsLimit={25}
              onShowMore={handleShowMore}
              tableStaticHeaderRows={staticHeader}
              onSortEnd={handleSort}
            />
          </div>
        ) : (
          <AlertBlock type="warning" iconClass="hicon-warning">
            <p>Sorry, the Top Apps report is not available for apps matching these criteria.</p>
          </AlertBlock>
        )}
      </div>
    </div>
  );
};

TopPublishersTable.propTypes = {
  report: T.object.isRequired,
  onShowMore: T.func.isRequired,
};

export default TopPublishersTable;
